import { FC, useCallback, useEffect, useState } from "react";
import { getTimeLeftDetail } from "../../../utils/time";
import styles from './ChallengeDetail.module.scss';

interface ITimeLeftDisplayProps {
    finishDate: number;
}

export const ChallengeTimeLeftBlock: FC<ITimeLeftDisplayProps> = ({ finishDate }) => {
    const [timeLeft, setTimeLeft] = useState<string>("");

    const updateTimeLeft = useCallback(() => {
        setTimeLeft(getTimeLeftDetail(finishDate, -1, 2));
    }, [finishDate]);

    useEffect(() => {
        updateTimeLeft();

        const intervalId = setInterval(updateTimeLeft, 1000);
        return () => clearInterval(intervalId);
    }, [updateTimeLeft]);

    return (
        <span>
            {`Осталось: `}
            <span className={styles.value}>{timeLeft}</span>
        </span>
    );
};